export const unwrapWishlistResponse = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }

    if (payload.wishlistData) {
        return payload.wishlistData;
    }

    if (payload.data && payload.data.wishlistData) {
        return payload.data.wishlistData;
    }

    return payload;
};
